export default "__VITE_PUBLIC_ASSET__0279e658__"